var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "nav-section" }, [
      _c(
        "a",
        {
          staticClass: "nav-back",
          on: {
            click: function ($event) {
              return _vm.navToTenantTab()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("back")))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "header-name" }, [
        _vm._v("\n      " + _vm._s(_vm.getHeaderName()) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-wrapper tenancies-table-wrapper" }, [
      _c("div", { staticClass: "table-caption" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("tenancy.tenancyRecordList")) + "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.filteredTenancyHeaders, function (header, index) {
              return _c(
                "th",
                {
                  key: "tenacy_header_" + index,
                  class: header.class,
                  on: {
                    click: function ($event) {
                      return _vm.sortTenanciesBy(header.code)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(header.name) +
                      " " +
                      _vm._s(
                        _vm.orderbyAttr === header.code
                          ? _vm.reverse
                            ? "▼"
                            : "▲"
                          : null
                      ) +
                      "\n          "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.tenancies, function (item, index) {
            return _c("tr", { key: "tenancy_user_" + index }, [
              _c(
                "td",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "name-hyper-link",
                      attrs: {
                        to: {
                          name: "ccdTenancyTenantView",
                          params: { id: item.id },
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.name || "--") +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.deep(item, "TenancyAccount.contactFirstName") || "--"
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.deep(item, "TenancyAccount.contactLastName") || "--"
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm.deep(item, "TenancyAccount.isAdmin")
                  ? _c("input", {
                      attrs: {
                        id: "settings-tenants-checkbox-is-master-" + index,
                        type: "checkbox",
                        disabled: true,
                      },
                      domProps: { checked: true },
                    })
                  : _c("span", [_vm._v("-")]),
              ]),
              _vm._v(" "),
              _vm.enableTenantProjectsFeature
                ? _c("td", [
                    !!item.TenancyAccount.perms["TenantProject"]
                      ? _c("input", {
                          attrs: {
                            id:
                              "settings-tenants-checkbox-is-projects-" + index,
                            type: "checkbox",
                            disabled: true,
                          },
                          domProps: { checked: true },
                        })
                      : _c("span", [_vm._v("-")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.enableTenantProjectsFeature
                ? _c("td", [
                    !!item.TenancyAccount.perms["HandoverTakeback"]
                      ? _c("input", {
                          attrs: {
                            id: "settings-tenants-checkbox-is-hotb-" + index,
                            type: "checkbox",
                            disabled: true,
                          },
                          domProps: { checked: true },
                        })
                      : _c("span", [_vm._v("-")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.enableWorkPermitsFeature
                ? _c("td", [
                    !!item.TenancyAccount.perms["StandaloneWorkPermits"]
                      ? _c("input", {
                          attrs: {
                            id:
                              "settings-tenants-checkbox-is-standaloneWP-" +
                              index,
                            type: "checkbox",
                            disabled: true,
                          },
                          domProps: { checked: true },
                        })
                      : _c("span", [_vm._v("-")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [
                !!item.TenancyAccount.perms["TenancyRecord"]
                  ? _c("input", {
                      attrs: {
                        id: "settings-tenants-checkbox-is-manage-" + index,
                        type: "checkbox",
                        disabled: true,
                      },
                      domProps: { checked: true },
                    })
                  : _c("span", [_vm._v("-")]),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.dateUtil.formatDate(
                      _vm.deep(item, "TenancyAccount.invitedAt"),
                      true
                    )
                  )
                ),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        staticClass: "table-wrapper project-table-wrapper",
      },
      [
        _c("div", { staticClass: "table-caption" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("tenancy.projectList")) + "\n    "),
        ]),
        _vm._v(" "),
        _c("table", [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.projectHeaders, function (header, index) {
                return _c(
                  "th",
                  {
                    key: "project_header_" + index,
                    class: header.class,
                    on: {
                      click: function ($event) {
                        return _vm.sortBy(header.code)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(header.name) +
                        " " +
                        _vm._s(
                          _vm.orderProjectAttr === header.code
                            ? _vm.reverseProjects
                              ? "▼"
                              : "▲"
                            : null
                        ) +
                        "\n          "
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.projects, function (item, index) {
              return _c("tr", { key: "TP_detail_" + index }, [
                _c("td", [_vm._v(_vm._s(item.name || "--"))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.tenancyName || "--"))]),
              ])
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }